import map from 'lodash/map'
import { BlogStatus } from '@ztechapps/blog.common'

export const blogStatuses = map(BlogStatus, (item) => item.value)

export const blogStatusOptions = map(blogStatuses, (value) => ({ label: value, value }))
